import React from "react";
import { ClipLoader } from "react-spinners";

export const Loaderpage = () => {
    return (
        <>
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999
            }}>
                <ClipLoader color="#0d6efd" size={60} />
            </div>
        </>
    )
}